// extracted by mini-css-extract-plugin
export default {"container":"AdminHome_container__7pxWk","title":"AdminHome_title__+uX1G","buttonContainer":"AdminHome_buttonContainer__AFmyd","button":"AdminHome_button__574wB"};